import classNames from 'classnames';
import { marketplaceDisplayName } from 'ui/Strategies/config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const GoToMarketPlaceBanner = () => {
  const marketplaceBannerClassNames = classNames(
    'marketplace-banner rounded  mt-md-0  mb-md-6 master-domain-only',
    {'d-none': ApplicationDomainUtility.isAlgoverse}
  );

  return (
    <div className={marketplaceBannerClassNames}>
      <div className="d-flex flex-wrap flex-sm-nowrap align-items-center">
        <div className="w-100 mr-0 mb-3 mr-sm-10 mb-sm-0">
          <h1 className="text-white tx-25 font-weight-bold">{marketplaceDisplayName}</h1>
          <p className="tx-14 text-white mt-1 mb-0">
            Explore a world of trading strategies, where you choose and deploy from professionally curated
            strategies.
          </p>
        </div>

        <div>
        <button
          type="button"
          className="explore-btn"
          onClick={() => { window.location.href = '/strategies'; }}
        >
          Explore Now
         
        </button>
        </div>
      </div>
    </div>
  );
};

GoToMarketPlaceBanner.propTypes = {};

export default GoToMarketPlaceBanner;
